<template>
  <v-container
    id="dashboard"
    fluid
    tag="section"
  >
    <v-snackbar xs12
      v-model="snackbar"
      multi-line
      :timeout="timeout"
      top
      color="orange"
    >
      {{ alertmessage }}
      <v-btn
        color="white"
        text
        @click="snackbar = false"
      >
        Close
      </v-btn>
    </v-snackbar>  
 <sequential-entrance fromTop>
  
<v-row>
  <v-col>
    <base-material-card
      color="primary"
      icon="mdi-arrow-down"
      inline
    >
      <template v-slot:after-heading>
        <div class="display-2 font-weight-light">
          Deposit in Transit for {{sitedetails.idnum}} 
        </div> 
      </template>
  <v-data-table
    :headers="headers"
    :items="getdepositusers"
    sort-by="timestamp"
    sort-desc
    class="elevation-1"
  >
  
    <template v-slot:top>
      <v-toolbar flat color="white">
        <v-toolbar-title>Pending Deposits</v-toolbar-title>

        <v-divider
          class="mx-4"
          inset
          vertical
        ></v-divider>
        <v-spacer></v-spacer>
        <v-dialog v-model="dialog" max-width="500px">
          <template v-slot:activator="{ on }">
            <v-btn color="warning" dark class="mb-2" to="/Depositactions">Return</v-btn><v-btn color="primary" dark class="mb-2 mr-4" v-on="on">New Deposit in Transit</v-btn>
          </template>
          <template v-slot:item.timestamp="{ item }">
            {{format_time(item.timestamp)}}
          </template>    
          <v-card>
            <v-card-title>
              <span class="headline">{{ formTitle }}</span>
            </v-card-title>

            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12" sm="12" md="12">
                    <v-text-field v-model="editedItem.washifyid" label="ID"></v-text-field>
                  </v-col>                  
                  <v-col cols="12" sm="12" md="12">
                    <v-text-field v-model="editedItem.source" label="Source"></v-text-field>
                  </v-col>                                       
                  <v-col cols="12" sm="12" md="12">
                    <v-text-field :rules="numeric_only" v-model="editedItem.amount" label="Deposit Amount"></v-text-field>
                  </v-col>                              
                  <v-col cols="12" sm="12" md="12">
                    <v-select :items="transitTime" v-model="editedItem.duration" label="Transit Duration"></v-select>
                  </v-col>
                  <v-card-title>
                    <span class="body light">Deposit Transit will be active once saved</span>
                  </v-card-title>
      
                </v-row>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
              <v-btn color="blue darken-1" :disabled="!formIsValid" text @click="save">Save</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-toolbar>
    </template>
    <template v-slot:item.modify="{ item }">
      <v-icon color="primary" size="20" @click="editItem(item)">
        mdi-square-edit-outline
      </v-icon>
      <v-icon color="black" size="20" class="ma-4" @click="deleteItem(item)">
        mdi-delete
      </v-icon>
    </template>
    <template v-slot:no-data>
      Sorry, No deposit info {{sitedetails.idnum}}
    </template>
  </v-data-table>      
  <v-data-table
    :headers="completedheaders"
    :items="getcompleted"
    :search="search"
    sort-by="timestamp"
    sort-desc
    class="elevation-1"
  >
  
    <template v-slot:top>
      <v-toolbar flat color="white">
        <v-toolbar-title>Completed Deposits</v-toolbar-title>

        <v-divider
          class="mx-4"
          inset
          vertical
        ></v-divider>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Search"
          single-line
          hide-details
        ></v-text-field>        
        <v-spacer></v-spacer>
      </v-toolbar>
    </template>
    <template v-slot:no-data>
      Sorry, No deposit info for {{sitedetails.idnum}}
    </template>
  </v-data-table>
    </base-material-card>

    <div class="py-3" />
  </v-col>
</v-row>
   </sequential-entrance>

  </v-container>
</template>

<script>
  const axios = require('axios')
  import moment from 'moment'
  var numeral = require('numeral')
  import { utcToZonedTime, format } from 'date-fns-tz'

  export default {
    name: 'Depositusersbysite',
    props: ['id'],    
    data: () => ({
      dialog: false,
      sitedetails: '',
      snackbar: false,
      timeout: 5000,
      search: '',
      alertmessage: '',
      headers: [
        { text: 'Local Time', align: 'center', value: 'localtime' },
        { text: 'Status', align: 'center', value: 'status', sortable: false },
        { text: 'Source', align: 'center', value: 'source'},
        { text: 'ID', align: 'center', value: 'washifyid'},        
        { text: 'Amount', align: 'center', value: 'amount' },
        { text: 'Duration (mins)', align: 'center', value: 'duration' },
        { text: 'Modify', align: 'center', value: 'modify' },
      ],          
      completedheaders: [
        { text: 'Local Time', align: 'center', value: 'localtime' },
        { text: 'Status', align: 'center', value: 'status', sortable: false },
        { text: 'Source', align: 'center', value: 'source'},
        { text: 'ID', align: 'center', value: 'washifyid'},
        { text: 'Amount', align: 'center', value: 'amount' },
        { text: 'Duration (mins)', align: 'center', value: 'duration' },
      ],
      numeric_only: [
        // v => !!v || 'Please set empty fields to 0',
        v => /^[0-9]*$/.test(v) || 'Numeric values only',
      ],
      alerts: [],
      depositusers: [],
      transitTime: [1,15,30,45,60,90,120],
      typeList: ['Standard', 'Cit'],
      editedIndex: -1,
      editedItem: {
        timestamp: '',
        duration: '',
        washifyid: '',
        source: '',
        status: '',
        userid: '',
        amount: '',
      },
      defaultItem: {
        timestamp: '',
        duration: '',
        washifyid: '',
        status: '',
        userid: '',
        amount: '',
        source: '',
      },
    }),

    computed: {
      formIsValid () {
        return this.editedItem.email !== '' &&
        this.editedItem.accesscode !== '' &&
        this.editedItem.username !== ''
      },    
      formTitle () {
        return this.editedIndex === -1 ? 'New Deposit in Transit' : 'Edit Deposit in Transit'
      },
      getalerts () {
        this.alerts = this.$store.getters.alerts
        return this.alerts
      },
      getdepositusers () {
        let pending
        pending = this.$store.getters.loadedPendingDeposits

        let output
        for (let dep in pending) {
          this.$log.debug(' LOCAL FUNC ', this.sitedetails)
          let output
          if (this.sitedetails.timezone && this.sitedetails.timezone === 'EST') {
            // Obtain a Date instance that will render the equivalent Berlin time for the UTC date 
            let locdate = pending[dep].timestamp
            let timeZone = 'America/New_York'
            let zonedDate = utcToZonedTime(locdate, timeZone)
            // zonedDate could be used to initialize a date picker or display the formatted local date/time
            
            // Set the output to "1.9.2018 18:01:36.386 GMT+02:00 (CEST)"
            let pattern = 'yyyy-MM-dd HH:mm:ss'
            output = format(zonedDate, pattern, { timeZone })  
            this.$log.debug(' est format is ', output)  
          }
          else if (this.sitedetails.timezone && this.sitedetails.timezone === 'GMT') {
            // Obtain a Date instance that will render the equivalent Berlin time for the UTC date 
            let locdate = pending[dep].timestamp
            let timeZone = 'Europe/London'
            let zonedDate = utcToZonedTime(locdate, timeZone)
            // zonedDate could be used to initialize a date picker or display the formatted local date/time
            
            // Set the output to "1.9.2018 18:01:36.386 GMT+02:00 (CEST)"
            let pattern = 'yyyy-MM-dd HH:mm:ss'
            output = format(zonedDate, pattern, { timeZone })
            this.$log.debug(' GMT format is ', output)
          }
          else if (this.sitedetails.timezone && this.sitedetails.timezone === 'PST') {
            // Obtain a Date instance that will render the equivalent Berlin time for the UTC date 
            let locdate = pending[dep].timestamp
            let timeZone = 'America/Los_Angeles'
            let zonedDate = utcToZonedTime(locdate, timeZone)
            // zonedDate could be used to initialize a date picker or display the formatted local date/time
            
            // Set the output to "1.9.2018 18:01:36.386 GMT+02:00 (CEST)"
            let pattern = 'yyyy-MM-dd HH:mm:ss'
            output = format(zonedDate, pattern, { timeZone })
            this.$log.debug(' PST format is ', output)
          }
          else if (this.sitedetails.timezone && this.sitedetails.timezone === 'MST') {
            // Obtain a Date instance that will render the equivalent Berlin time for the UTC date 
            let locdate = pending[dep].timestamp
            let timeZone = 'America/Denver'
            let zonedDate = utcToZonedTime(locdate, timeZone)
            // zonedDate could be used to initialize a date picker or display the formatted local date/time
            
            // Set the output to "1.9.2018 18:01:36.386 GMT+02:00 (CEST)"
            let pattern = 'yyyy-MM-dd HH:mm:ss'
            output = format(zonedDate, pattern, { timeZone })
            this.$log.debug(' PST format is ', output)
          }
          else if (this.sitedetails.timezone && this.sitedetails.timezone === 'CST') {
            // Obtain a Date instance that will render the equivalent Berlin time for the UTC date 
            let locdate = pending[dep].timestamp
            let timeZone = 'America/Chicago'
            let zonedDate = utcToZonedTime(locdate, timeZone)
            // zonedDate could be used to initialize a date picker or display the formatted local date/time
            
            // Set the output to "1.9.2018 18:01:36.386 GMT+02:00 (CEST)"
            let pattern = 'yyyy-MM-dd HH:mm:ss'
            output = format(zonedDate, pattern, { timeZone })
            this.$log.debug(' PST format is ', output)
          }          
        Object.assign(pending[dep], {localtime:output}) 
        }
        console.log('pending ', pending)
        return pending
      },
      getcompleted() {
        // format timestamp for local safe time
        console.log(this.sitedetails.timezone)
        let completed = this.$store.getters.loadedCompletedDeposits
        let output
        for (let dep in completed) {
          this.$log.debug(' LOCAL FUNC ', this.sitedetails)
          let output
          if (this.sitedetails.timezone && this.sitedetails.timezone === 'EST') {
            // Obtain a Date instance that will render the equivalent Berlin time for the UTC date 
            let locdate = completed[dep].timestamp
            let timeZone = 'America/New_York'
            let zonedDate = utcToZonedTime(locdate, timeZone)
            // zonedDate could be used to initialize a date picker or display the formatted local date/time
            
            // Set the output to "1.9.2018 18:01:36.386 GMT+02:00 (CEST)"
            let pattern = 'yyyy-MM-dd HH:mm:ss'
            output = format(zonedDate, pattern, { timeZone })  
            this.$log.debug(' est format is ', output)  
          }
          else if (this.sitedetails.timezone && this.sitedetails.timezone === 'GMT') {
            // Obtain a Date instance that will render the equivalent Berlin time for the UTC date 
            let locdate = completed[dep].timestamp
            let timeZone = 'Europe/London'
            let zonedDate = utcToZonedTime(locdate, timeZone)
            // zonedDate could be used to initialize a date picker or display the formatted local date/time
            
            // Set the output to "1.9.2018 18:01:36.386 GMT+02:00 (CEST)"
            let pattern = 'yyyy-MM-dd HH:mm:ss'
            output = format(zonedDate, pattern, { timeZone })
            this.$log.debug(' GMT format is ', output)
          }
          else if (this.sitedetails.timezone && this.sitedetails.timezone === 'PST') {
            // Obtain a Date instance that will render the equivalent Berlin time for the UTC date 
            let locdate = completed[dep].timestamp
            let timeZone = 'America/Los_Angeles'
            let zonedDate = utcToZonedTime(locdate, timeZone)
            // zonedDate could be used to initialize a date picker or display the formatted local date/time
            
            // Set the output to "1.9.2018 18:01:36.386 GMT+02:00 (CEST)"
            let pattern = 'yyyy-MM-dd HH:mm:ss'
            output = format(zonedDate, pattern, { timeZone })
            this.$log.debug(' PST format is ', output)
          }
          else if (this.sitedetails.timezone && this.sitedetails.timezone === 'MST') {
            // Obtain a Date instance that will render the equivalent Berlin time for the UTC date 
            let locdate = completed[dep].timestamp
            let timeZone = 'America/Denver'
            let zonedDate = utcToZonedTime(locdate, timeZone)
            // zonedDate could be used to initialize a date picker or display the formatted local date/time
            
            // Set the output to "1.9.2018 18:01:36.386 GMT+02:00 (CEST)"
            let pattern = 'yyyy-MM-dd HH:mm:ss'
            output = format(zonedDate, pattern, { timeZone })
            this.$log.debug(' PST format is ', output)
          }
          else if (this.sitedetails.timezone && this.sitedetails.timezone === 'CST') {
            // Obtain a Date instance that will render the equivalent Berlin time for the UTC date 
            let locdate = completed[dep].timestamp
            let timeZone = 'America/Chicago'
            let zonedDate = utcToZonedTime(locdate, timeZone)
            // zonedDate could be used to initialize a date picker or display the formatted local date/time
            
            // Set the output to "1.9.2018 18:01:36.386 GMT+02:00 (CEST)"
            let pattern = 'yyyy-MM-dd HH:mm:ss'
            output = format(zonedDate, pattern, { timeZone })
            this.$log.debug(' PST format is ', output)
          }          
        Object.assign(completed[dep], {localtime:output}) 
        }

        return completed
      }
    },

    watch: {
      dialog (val) {
        val || this.close()
      },
    },

    created () {
      this.id = this.$route.params.id
      this.getsitemap(this.id)
      this.$log.debug('LOADING THIS ID ', this.id)
      this.initialize()
    },
    beforeDestroy () {
      this.$store.dispatch('stoprealtimependingdeposits', this.id)
      this.$store.dispatch('stoprealtimecompleteddeposits', this.id)
    },
    methods: {
      initialize () {
        this.alerts = this.$store.getters.alerts
        this.depositusers = this.$store.getters.loadedPendingDeposits
      },
      format_time(ts) {
        this.$log.debug("TS ", ts);
        return moment(ts).format("MM-DD-YY, HH:mm:ss");
      },      
      getsitemap (machineid) {
        this.$log.debug('sitemap')
        this.$store.dispatch("loadPendingDeposits", machineid)
        this.$store.dispatch('initrealtimependingdeposits', machineid)
        this.$store.dispatch('initrealtimecompleteddeposits', machineid)
        for (let [key, value] of Object.entries(this.$store.getters.loadedSiteProfiles)) {
          // this.$log.debug(`${key}: ${value}`)
          if (value.siteunitsprofile) {
            if (value.siteunitsprofile[0].crypto_idnum===machineid) {
              this.$log.debug(value)
              this.sitedetails = this.$store.getters.loadedSites.find(location => value.idnum === location.idnum)
            }
          }

        }


      },
      editItem (item) {
        this.editedIndex = this.depositusers.indexOf(item)
        this.$log.debug('edited index is ', this.editedIndex, 'edited item was ', item, 'alerts array is ', this.depositusers)
        this.editedItem = Object.assign({}, item)
        this.dialog = true
      },

      deleteItem (item) {
        const index = this.depositusers.indexOf(item)
        this.$log.debug('site info is ', item)
        if (confirm('Are you sure you want to delete this item?') && this.depositusers.splice(index, 1)) {
          this.$log.debug('site info is ', item.key)
          let rec = {
            key: item.key,
            siteid: this.id
          }
          this.$store.dispatch('removePendingDeposit', rec)
        }
      },

      close () {
        this.dialog = false
        setTimeout(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        }, 300)
      },

      save () {
        let allowedchars = ""
        allowedchars = this.editedItem.userid.match(/^[0-9]*$/gi)
        this.$log.debug('allowedchars ', allowedchars)
        if (!allowedchars) {
          this.alertmessage = 'Only numbers are allowed in USER IDs'
          this.snackbar = true
          this.close()
          return
        }
        this.$log.debug('EDITED INDEX WAS ', this.editedIndex)
        const deposit = {
          siteid: this.id,
          timestamp: Date.now(),
          userid: this.editedItem.userid.trim(),
          amount: this.editedItem.amount,
          source: this.editedItem.source,
          washifyid: this.editedItem.washifyid,
          status: 'Pending',
          duration: this.editedItem.duration,
          key: this.editedItem.key
        }
        if (this.editedIndex > -1) {
          let rec = {
            siteid: deposit.siteid,
            status: deposit.status,
            timestamp: deposit.timestamp,
            userid: deposit.userid,
            washifyid: deposit.washifyid,
            duration: deposit.duration,
            source: deposit.source,
            amount: deposit.amount,
            key: deposit.key,
          }
          let visrec = rec
          visrec.timestamp = moment(rec.timestamp).format('YYYY-MM-DD HH:mm:ss')
          Object.assign(this.depositusers[this.editedIndex], visrec)
          this.$log.debug('CALLING UPDATE IN VIEW ')
          this.$store.dispatch('updatePendingDeposit', rec)
          this.depositusers = this.$store.getters.loadedPendingDeposits
          this.$store.dispatch('loadPendingDeposits', this.id)
          // this.$store.dispatch('updateDeposituser', user)
          this.close()
        } else {
          this.$store.dispatch('createPendingDeposit', deposit)
          let visrec = deposit
          visrec.timestamp = moment(deposit.timestamp).format('YYYY-MM-DD HH:mm:ss')          
          this.depositusers.push(visrec)

          this.$store.dispatch('loadPendingDeposits', this.id)
          // this.depositusers = this.$store.getters.depositusers
          this.close()
        }
        this.close()
      },
    },
  }
</script>

